import { dialogOverlay } from '@/components/Platforms/Dialogs/styles';
import { GenericModal } from '@/components/shared/GenericModal';

import { DialogContent, Box } from '@mui/material';
import { GenericIdmsTable } from '@/components/Analysis/shared/EquipmentsTab/PipesAndSpanTables/GenericIdmsTable';
import { PipesAndSpanColumns } from '@/types';

type Props = {
  onClose: () => void;
  open: boolean;
  tableRows: Record<string, unknown>[];
  columns: PipesAndSpanColumns[];
  loading?: boolean;
  title?: string;
};

export const PipeSupportModalTable = ({
  open,
  onClose,
  tableRows = [],
  columns = [],
  loading = false,
  title,
}: Props) => {
  const modalMaxVh = 88;
  const headerAndPaddingPx = 120;

  return (
    <GenericModal
      open={open}
      title={title ?? 'Associated Piping'}
      handleClose={onClose}
      crossIconStyle={{ backgroundColor: 'transparent' }}
      sx={{ ...dialogOverlay, left: '55rem', top: '15rem' }}
      backgroundPaperStyle={{
        height: 'auto',
        width: '80rem',
        maxHeight: `${modalMaxVh}vh`,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <DialogContent
        sx={{
          p: 2,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          height: '100%',
          minHeight: 0,
        }}
      >
        <Box
          sx={{
            overflowY: 'auto',
            flex: '1 1 auto',
            minHeight: 0,
            maxHeight: `calc(${modalMaxVh}vh - ${headerAndPaddingPx}px)`,
          }}
        >
          <GenericIdmsTable tableRows={tableRows} columns={columns} loading={loading} />
        </Box>
      </DialogContent>
    </GenericModal>
  );
};
